export const translationsDashboard_en_part2 = {
  assign: "Assign",
  assignedTo: "Assigned to",
  assignedToMe: "Assigned to me",
  assignedToYou: "Assigned to you",
  unassign: "Unassign",
  unassigned: "Unassigned",
  unknownUser: "Unknown user",
  resolutionRate: "Resolution rate",
  handoverRequiredRate: "Customer service required",
  fallbackRate: "Fallback Rate",
  userRequestedCustomerServiceRate: "User requested customer service",
  resolutionCategoryContained: "Resolved without handover",
  resolutionCategoryHandoverRequired: "Customer service required",
  resolutionCategoryFallback: "Fallback",
  resolutionCategoryCustomerRequestedService: "User requested customer service",
  resolutionCategoryFilterApplied: "Showing conversations with",
  commentsLabel: "Comments",
  noComments: "No comments yet",
  usernamePlaceholder: "Your name",
  addCommentPlaceholder: "Add a comment...",
  addComment: "Add comment",
  adding: "Adding...",
  editComment: "Edit comment",
  deleteComment: "Delete comment",
  confirmDeleteComment: "Are you sure you want to delete this comment?",
  save: "Save",
  cancel: "Cancel",
  commentPlaceholder: "Comment",
  unreadComments: "Unread comments",
  uploadingImage: "Uploading image...",
  imageUploadFailed: "Could not upload image.",
  reportImageAlt: "Report image",
  removeImage: "Remove image",
  uploadImage: "Upload image",
  mentionedConversationsFilter: "Mentioned me",
  mentionFilterEmpty: "No unresolved reports where you were mentioned match your filters.",
  mentionAllTeam: "@all",
  mentionAllTeamHint: "Everyone in the organization",
  mentionSomeone: "Mention someone",
  insertEmoji: "Insert emoji",
  mentionReportParticipant: "Participant in this report",
  adminUnreadCommentsMarker: "Admins: unread comments are available in this filter",
  markAllUnreadCommentsRead: "Mark all as read",
  markingUnreadCommentsRead: "Clearing...",
  unreadMentionBadge: "Unread mention",
  mentionFeatureAnnouncementTitle: "New: Assign and mention teammates",
  mentionFeatureAnnouncementP1:
    "In reports, you can assign the conversation to a teammate or type @ in the comment field to mention specific people.",
  mentionFeatureAnnouncementP2:
    "Use @all for the whole organization. Unread unresolved reports you follow appear in the filter, and you can clear old unread comments in one action.",
  mentionFeatureAnnouncementOk: "Got it",
  mentionFeatureAnnouncementDontShowAgain: "Don't show this message again",
  // Product button translation
  // Product button translation
  viewProduct: "VIEW PRODUCT",
  companyInfo: "Company Information",
  livechat: "Livechat",
  // Context chunks translations
  // Context chunks translations
  showContext: "Show context sources",
  hideContext: "Hide context sources",
  loadingContextChunks: "Loading context...",
  noContextChunks: "No context information available for this message.",
  contextUsed: "Context used to generate this response:",
  source: "Source",
  relevance: "relevance",
  contextChunkOriginUploaded: "Uploaded",
  contextChunkOriginScrapedPage: "Scraped page",
  page: "Page",
  conversationUnavailable: "This conversation has been deleted or is no longer available to you.",
  // AI debug data translations (admin only)
  // AI debug data translations (admin only)
  showAiDebug: "Show AI debug info",
  hideAiDebug: "Hide AI debug info",
  loadingAiDebug: "Loading AI debug info...",
  noAiDebug: "No AI debug information available for this message.",
  aiDebugTitle: "AI Debug Information",
  urlValidatorLabel: "URL validator corrections",
  vectorStoreLabel: "Vector store",
  vectorStorePgvector: "pgvector",
  searchMethodLabel: "Search method",
  searchMethodKeywordFallback: "Keyword search · automatic fallback",
  searchMethodKeywordFallbackDescription:
    "Question embedding failed or timed out. This reply used pgvector keyword search instead of semantic search.",
  searchMethodKeywordOnly: "Keyword search · configured in flow",
  searchMethodKeyword: "Keyword search",
  searchMethodSemantic: "Semantic search",
  llmProviderLabel: "LLM provider",
  llmProviderVertex: "Google Vertex",
  llmProviderBedrock: "AWS Bedrock",
  llmProviderOpenai: "OpenAI",
  llmFallbackReasonLabel: "LLM fallback reason",
  fallbackReasonLabel: "Retrieval fallback reason",
  rephraseLabel: "Rephrased question",
  fordelingsflowLabel: "Fordelingsflow result",
  metadataFiltersLabel: "Metadata filters",
  hardcodedMetadataFilterLabel: "Hardcoded metadata filter",
  noRephrase: "No rephrase (first message or greeting)",
  noFordelingsflow: "No fordelingsflow executed",
  agentExecutionLogLabel: "Integration handling (pre-stream)",
  noMetadataFilters: "No metadata filters applied",
  noHardcodedMetadataFilter: "No hardcoded metadata filter",
  metadataFilterSuccessBanner: "Filter returned results",
  hardcodedFilterFellBackLabel: "Hardcoded filter fell back to unfiltered search:",
  hardcodedFilterFellBackBanner:
    "Hardcoded filter returned no results - fell back to unfiltered search",
  hardcodedFilterSuccessBanner: "Hardcoded filter returned results",
  topicFilterApplied: "Filtered by topic",
  purchaseFilterApplied: "Showing conversations with purchases",
  leadsFilterApplied: "Showing leads",
  timePeriod: "Time period",
  timePeriodAll: "All",
  timePeriodToday: "Today",
  timePeriodYesterday: "Yesterday",
  timePeriodThisWeek: "This week",
  timePeriodLast7Days: "Last 7 days",
  timePeriodThisMonth: "This month",
  timePeriodLast30Days: "Last 30 days",
  timePeriodFilterApplied: "Filtered by time period",
  filterApplied: "Filter applied",
  uploadData: "Upload Data",
  editSubject: "Edit subject",
  selectSubject: "Select subject...",
  open: "Open",
  closed: "Closed",
  leads: "Contact form",
  testConversation: "Test Conversation",
  sessionContext: "Session context",
  conversationProductClicked: "Product clicked",
  conversationLinkClicked: "Link clicked",
  conversationNoRecordedClicks: "No recorded clicks",
  draftUsageWordsRetained: "{{matched}} of {{draft}} draft words in a {{response}}-word reply",
  emailSenderAgent: "Customer service",
  emailSenderAgentVia: "Sent from {{provider}}",
  emailSenderDraft: "AI draft",
  emailSenderDraftDescription: "Suggested reply, not sent to the customer",
  emailSenderNote: "Internal note",
  emailSenderNoteDescription: "Not visible to the customer",
  emailSenderSent: "Sent by automation",
  emailSenderSentDescription: "AI reply sent to the customer automatically",
  emailDraftUsageReply: "{{percentage}}% match with the AI draft",
  verifiedMetadataLabel: "Verified customer data",
  sessionMetadataLabel: "Session metadata",
  sessionMetadataUnverified: "Unverified",
  sessionMetadataHint: "Provided by the visitor’s browser. These values are not verified.",
  sessionMetadataConversationEmail: "Email given before the chat",
  verifiedMetadataHint:
    "Signed by the customer's website and verified by us, so it can be trusted.",
  fieldTypeTextarea: "Text area",
  deviceLabel: "Device",
  deviceDesktop: "Desktop",
  deviceTablet: "Tablet",
  devicePhone: "Mobile",
  deviceNotRecorded: "Not recorded",
};
